<template>
  <div class="wrapper">

    <Background v-if="!loading"/>

    <Nav v-if="!loading" :fixed="true">
      <template v-slot:logo-box>
        <Logo scaleMode="playMode"/>
      </template>
      <template v-slot:options-box>
        <DialoguesButton scaleMode="playMode"/>
        <Title :title="getTitle" scaleMode="playMode"/>
        <EditButton :shortId="getShortId" :ownerId="getOwner" :type="getType" scaleMode="playMode"/>
        <PinButton :shortId="getShortId" :ownerId="getOwner" :type="getType" :exerciseId="getExerciseId" scaleMode="playMode"/>
      </template>
      <template v-slot:play-modes-box>
        <PlayModesButtons :exerciseId="getExerciseId" :activePlayModes="getActivePlayModes" @restart="onRestart"/>
      </template>
    </Nav>

    <div class="loading" v-if="loading">
      <Loader color="white"/>
    </div>
    
    <div :class="{ main: true }" v-if="!loading">
      <div class="history">
        <div class="row-box">
          <Row v-for="(row, index) in history" :key="index" :object="row"/>
        </div>
      </div>
      <div class="container">

        <div class="person-box">
          <Person/>
        </div>

        <div class="dialog-box">
          <div class="dialog">
            <div :class="dialogAnimation">
              <div class="question-box">
                <Bot v-for="object in question" :key="object.id" :data="object" :hideSpeaker="hideSpeaker" @showAnswers="onShowAnswers"/>
              </div>
              <div class="answer-box">
                <div class="selected-answer" v-for="answer in selectedAnswer" :key="answer.id">
                  <div class="text">{{ getHint }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="answers">
            <div class="answers-box">
              <Answer v-for="answer in answers" :key="answer.id" :data="answer" :answerAnimation="answerAnimation" :hide="answersHide" :hideBar="hideSpeaker" @selected="selectAnswer" @end="onAnswerEnd" @stopRecording="onStopRecording"/>

              <div class="end-box" v-if="showEnd">
                <div class="options-row">
                  <button class="play-button" @click="playRecording">
                    <font-awesome-icon icon="play-circle" class="icon" v-if="!draftSaving"/>
                    <span v-if="!draftSaving">Play your recording</span>
                    <Loader color="white" :auto="true" v-if="draftSaving"/>
                  </button>
                  <button class="again-button" @click="onRestart">
                    <font-awesome-icon icon="microphone" class="icon"/>
                    <span>Record again</span>
                  </button>
                </div>
                <div class="send-row">
                  <div class="label-box">
                    <span v-if="getSaveState.type == 'save'">Your recording was sent!!!</span>
                    <span v-else>Send to your teacher</span>
                  </div>
                  <div class="send-box">
                    <input type="text" class="send-input" placeholder="Your Name" v-model="sendName"  v-if="getSaveState.type != 'save'">
                    <button @click="sendRecording" v-if="getSaveState.type != 'save'">
                      <font-awesome-icon icon="paper-plane" class="icon" v-if="!sendSaving"/>
                      <span v-if="!sendSaving">Send</span>
                      <Loader color="white" :auto="true" v-if="sendSaving"/>
                    </button>
                    <div class="sended-box" v-if="getSaveState.type == 'save'">
                      <div class="label-long">Share your recording</div>
                      <div class="label-mid">Share recording</div>
                      <div class="label-short">Share</div>
                      <div class="link-button" @click="copyLink">
                        <font-awesome-icon :icon="['fas', 'link']" />
                      </div>
                      <div class="facebook-button" @click="shareOnFacebook">
                        <font-awesome-icon :icon="['fab', 'facebook-f']" />
                      </div>
                      <div class="twitter-button" @click="shareOnTwitter">
                        <font-awesome-icon :icon="['fab', 'twitter']" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import alert from '@/lib/alert'
import iframe from '@/lib/iframe'
import axios from 'axios'
import { mapActions, mapGetters } from 'vuex';
import Background from '@/components/Record/Background'
import Person from '@/components/Record/Person'

import Bot from '@/components/Record/Bot'
import Answer from '@/components/Record/Answer'
import Row from '@/components/Record/Row'
import Loader from '@/components/Loader'

//Nav
import Nav from '@/components/Nav/Nav'
import Logo from '@/components/Nav/Logo'
import DialoguesButton from '@/components/Nav/DialoguesButton'
import Title from '@/components/Nav/Title'
import EditButton from '@/components/Nav/EditButton'
import PinButton from '@/components/Nav/PinButton'
import PlayModesButtons from '@/components/Nav/PlayModesButtons'

export default {
  name: 'Record',
  data() {
    return {
      loading: true,
      question: [],
      answers: [],
      selectedAnswer: [],
      history: [],
      hideSpeaker: false,
      answerAnimation: false,
      answersHide: false,
      move_dialog: false,
      end: false,
      showEnd: false,
      animation: false,
      menu: false,
      sendName: '',
      continueButton: false,
      continueButtonHide: false,
      selectedAnswerId: null,
      timeouts: [],
      draftSaving: false,
      sendSaving: false,
    }
  },
  components: {
    Background,
    Person,
    Bot,
    Answer,
    Row,
    Loader,
    //Nav
    Nav,
    Logo,
    DialoguesButton,
    Title,
    EditButton,
    PinButton,
    PlayModesButtons
  },
  methods: {
    ...mapActions('record', ['clear', 'loadData', 'restart', 'saveDialog', 'saveDraft', 'nextQuestion']),
    ...mapActions('player', ['playerStop']),
    exit() {
      this.playerStop();
      this.$router.push(`/hub?exercise_id=${this.getExerciseId}`);
    },
    loadQuestion() {
      this.question = this.currentBotData;
    },
    loadAnswers() {
      if(this.currentAnswers.length > 0) {
        this.answers = this.currentAnswers;
      } else {
        this.answers = [];
        this.end = true;
        this.showEnd = true;
      }
    },
    selectAnswer(id) {
      this.selectedAnswerId = id;
      this.animation = true;
      this.answersHide = true;
      this.timeouts.push(setTimeout(() => {
        this.continueButton = true;
      }, 1500))
    },
    onContinue() {
      this.playerStop();
      this.continueButtonHide = true;
      this.timeouts.push(setTimeout(() => {
        this.continueButtonHide = false;
        this.continueButton = false;
      }, 1000))

      this.moveAnswer(this.selectedAnswerId);
      this.hideSpeaker = true;

      this.timeouts.push(setTimeout(() => {
        this.answers = [];
      }, 1100))

      this.timeouts.push(setTimeout(() => {
        this.lockScroll = true;
        this.moveDialog();
      }, 1100))

      let answerData = this.currentAnswers.find(answer => {
        return answer.id == this.selectedAnswerId;
      })
      if(answerData.next != undefined) {
        this.timeouts.push(setTimeout(() => {
          this.nextQuestion({ nextId: answerData.next,  answerId: answerData.id })
        }, 2000))
      } else {
        this.onAnswerEnd();
      }

      this.timeouts.push(setTimeout(() => {
        this.lockScroll = false;
        setTimeout(() => {
          let wrapper = document.querySelector('.wrapper');
          window.scrollTo(0, wrapper.scrollHeight);
        }, 1);
        this.clearForNext()
      }, 2000))

    },
    onAnswerEnd() {
      this.end = true;
    },
    moveAnswer(id) {
      this.answerAnimation = true;
      let answer = this.answers.filter(answer => {
        return answer.id == id;
      })
      this.selectedAnswer = answer;
    },
    moveDialog() {
      this.history.push({ question: this.question[0], answer: this.selectedAnswer[0] });
      this.move_dialog = true;
    },
    clearForNext() {
      this.animation = false;
      this.question = [];
      this.selectedAnswer = [];
      this.hideSpeaker = false;
      this.answerAnimation = false;
      this.answersHide = false;
      this.move_dialog = false;
      this.selectedAnswerId = null;
      if(!this.end) {
        this.timeouts.push(setTimeout(this.loadQuestion, 100))
        // this.timeouts.push(setTimeout(this.loadAnswers, 600))
      } else {
        this.showEnd = true;
      }
    },
    onRestart() {
      this.menu = false;
      this.restart();
      this.question = [];
      this.answers = [];
      this.selectedAnswer = [];
      this.history = [];
      this.hideSpeaker = false;
      this.answerAnimation = false;
      this.answersHide = false;
      this.move_dialog = false;
      this.end = false;
      this.showEnd = false;
      this.continueButton = false;
      this.continueButtonHide = false;
      this.selectedAnswerId = null;
      this.saveName = '';
      this.saveInput = true;

      this.timeouts.forEach(timeout => {
        clearTimeout(timeout);
      });
      this.timeouts = [];

      this.timeouts.push(setTimeout(this.loadQuestion, 100))
      // this.timeouts.push(setTimeout(this.loadAnswers, 600))
    },
    onStopRecording() {
      this.onContinue();
    },
    autoScroll() {
      function onElementHeightChange(elm, callback){
        var lastHeight = elm.clientHeight, newHeight;
        (function run(){
          newHeight = elm.clientHeight;
          if( lastHeight != newHeight )
            callback(newHeight)
          lastHeight = newHeight

              if( elm.onElementHeightChangeTimer )
                clearTimeout(elm.onElementHeightChangeTimer)

          elm.onElementHeightChangeTimer = setTimeout(run, 1)
        })()
      }

      onElementHeightChange(document.body, () => {
        window.scrollTo(0,document.body.scrollHeight);
      })
    },
    playRecording() {
      if(!this.getSavingState) {
        if(this.getSaveState.type == 'draft') {
          iframe.open(`${window.location.origin}/recording?dialog_id=${this.getSaveState.documentId}&type=draft`);
        }else if(this.getSaveState.type == 'save') {
          iframe.open(`${window.location.origin}/recording?dialog_id=${this.getSaveState.documentId}&type=save`);
        } else {
          this.draftSaving = true;
          this.saveDraft().then(() => {
            this.draftSaving = false;
            iframe.open(`${window.location.origin}/recording?dialog_id=${this.getSaveState.documentId}&type=draft`);
          }).catch(err => {
            this.draftSaving = false;
            alert.showError(err);
          })
        }
      } else {
        alert.showError('Currently Loading');
      }
    },
    sendRecording() {
      if(this.sendName.trim() != '') {
        this.sendSaving = true;
        this.saveDialog(this.sendName).then(() => {
          this.sendSaving = false;
        }).catch(err => {
          this.sendSaving = false;
          alert.showError(err);
        })
      } else {
        alert.showError('No name was given');
      }
    },
    onShowAnswers() {
      this.loadAnswers();
    },
    selectText(event) {
      event.target.select();
    },
    copyLink() {
      let fakeInput = document.createElement('input');
      fakeInput.id = 'fakeInput';
      fakeInput.style.opacity = 0;
      fakeInput.style.zIndex = 0;
      fakeInput.value = this.getShareLink;
      document.body.appendChild(fakeInput);
      document.body.querySelector('#fakeInput').select();
      document.execCommand('copy');
      document.body.removeChild(fakeInput);
    },
    shareOnFacebook() {
      // console.log('Facebook Share');
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${this.getShareLink}`, 'Share Frogero on Facebook', "height=auto,width=auto");
    },
    shareOnTwitter() {
      // console.log('Twitter Share');
      window.open(`https://twitter.com/intent/tweet?text=${this.getTitle}&url=${this.getShareLink}`, 'Share Frogero on Twitter', "height=auto,width=auto");
    }
  },
  created() {
    this.playerStop();
    this.clear();
    const urlParams = new URLSearchParams(window.location.search);
    const exerciseId = urlParams.get('exercise_id');
    
    this.loadData(exerciseId).then(() => {
      this.loading = false;
      this.timeouts.push(setTimeout(this.loadQuestion, 500))
      // this.timeouts.push(setTimeout(this.loadAnswers, 1000))
    }).catch(err => {
      alert.showError(err);
      this.$router.push('/');
    })
  },
  computed: {
    ...mapGetters('record', ['currentBotData', 'currentAnswers', 'getTitle', 'getShortId', 'getSavingState', 'getExerciseId', 'getSaveState', 'getOwner', 'getType', 'getActivePlayModes']),
    scroll() {
      if(document.querySelector('.main').offsetHeight + document.querySelector('.row-box').offsetHeight > window.innerHeight) {
        return true;
      } else {
        return false;
      }
    },
    dialogAnimation() {
      if(this.move_dialog) {
        if(document.querySelector('.main').offsetHeight + document.querySelector('.row-box').offsetHeight > window.innerHeight) {
          return {
            'new-dialog': true,
            'move_dialog_scroll': true
          }
        } else {
          return {
            'new-dialog': true,
            'move_dialog_no_scroll': true
          }
        }
      } else {
        return {
          'new-dialog': true
        }
      }
    },
    getHint() {
      let answer = this.selectedAnswer[0];
      if(answer.hint.trim() != '') {
        return answer.hint;
      } else {
        let array = answer.text.split(' ');
        if(array[0] && array[1]) {
          return `${array[0]} ${array[1]}...`;
        } else {
          return `${array[0]}...`;
        }
      }
    },
    getShareLink() {
      return `https://frogero.com/recording?dialog_id=${this.getSaveState.documentId}&type=save`;
    }
  },
  beforeRouteEnter(to, from, next) {
    const exerciseId = to.query.exercise_id;
    axios({
      method: 'post',
      url: `${process.env.VUE_APP_SERVER_URL}limitSolving`,
      data: {
        exerciseId
      }
    }).then(() => {
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}checkActivePlayModes`,
        data: {
          dialogId: exerciseId
        }
      }).then(result => {
        if(result.data.activePlayModes.record) {
          next(vm => {
            vm.routerFrom = from;
          });
        } else {
          alert.showWarning('This Play Mode is unavailable for this Dialog');
          next(`/hub?exercise_id=${exerciseId}`);
        }
      }).catch(() => {
        alert.showError('Loading Error');
      })
    }).catch(() => {
      console.log('Limit Error');
      alert.showError('Dialog limit reached');
      if(!from.name) {
        next(`/hub?exercise_id=${exerciseId}`);
      }
    })
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  min-height: 100vh;
  background-color: rgb(62, 64, 70);
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow-x: hidden;
}

.main {
  width: 100vw;
  flex: auto;
  z-index: 2;
  display: flex;
  flex-direction: column;
  position: relative;
  margin-top: 5rem;

  @media (min-width: 1600px) {
    width: 100rem;
  }
}

.history {
  z-index: 2;
  width: 100%;
  min-height: calc(35vh - 5rem);
  height: auto;
  display: grid;
  align-content: flex-end;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto;
  grid-template-areas: ". row row";
  @media (max-width: 1050px) {
    grid-template-areas: "row row row";
  }
  @media (max-width: 750px) {
    min-height: calc(25vh - 5rem);
  }
}

.row-box {
  grid-area: row;
  padding-bottom: 2rem;
}

.container {
  width: 100%;
  min-height: 65vh;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto;
  grid-template-areas: 
  ". dialog dialog"
  ". dialog dialog"
  ". dialog dialog";

  @media (max-width: 1050px) {
    grid-template-columns: 1fr;
    grid-template-areas: 
    "dialog"
    "dialog"
    "dialog";
  }

  @media (max-width: 750px) {
    min-height: 75vh;
  }
}

.person-box {
  position: fixed;
  height: 65vh;
  width: 33%;
  z-index: 0;
  bottom: 0;
  left: 0;
  @media (min-width: 1600px) {
    width: 33rem;
    left: calc((100vw - 100rem) / 2 );
  }
  @media (max-width: 1050px) {
    width: 50vw;
    max-height: 50vh;
  }
  @media (max-width: 750px) {
    width: 100vw;
    max-height: 50vh;
  }
}

.dialog-box {
  grid-area: dialog;
  display: flex;
  flex-direction: column;
}

.dialog {
  width: 100%;
  min-height: 8rem;
  display: flex;
}

.new-dialog {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  @media (max-width: 750px) {
    flex-direction: column;
  }
}

.move_dialog_no_scroll {
  animation: moveDialog 0.8s ease-out forwards;
  @keyframes moveDialog {
    0% {
      transform: translateY(0%);
    }
    100% {
      transform: translateY(calc(-100% - 2rem));
    }
  }
}

.move_dialog_scroll {
  transform: translateY(calc(-100% - 2rem));
}

.question-box {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  @media (max-width: 1050px) {
    align-items: center;
  }
  @media (max-width: 750px) {
    min-height: 6rem;
    height: auto;
    width: 100%;
    flex: unset;
    margin-bottom: 1rem;
  }
}

.answer-box {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  @media (max-width: 750px) {
    min-height: 4rem;
    height: auto;
    width: 100%;
    flex: unset;
  }
}

.selected-answer {
  width: 90%;
  min-height: 4rem;
  background-color: #edc270;
  border-radius: 0.5rem;
  display: flex;
  margin-bottom: 1rem;
  color: #4f4f4f;
  transition: 0.2s;
  padding-top: 1rem;
  padding-bottom: 1rem;
  opacity: 0;
  animation: answerAppear 1s forwards;

  @keyframes answerAppear {
    0% {
      opacity: 0;
    }
    99% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .text {
    flex: auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 1.2rem;
    word-break: break-word;
  }
}

.answers {
  width: 100%;
  flex: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.answers-box {
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;

  @media (max-width: 750px) {
    width: 100%;
  }
}


.end-box {
  width: 90%;
  height: 15rem;
  background-color: #43b64d;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;  
  transition: 0.2s;
  animation: endAppear 0.8s forwards;
  position: absolute;
  bottom: 4rem;
  @keyframes endAppear {
    0% {
      opacity: 0;
      transform: translateY(2rem);
    }
    100% {
      opacity: 1;
      transform: translateY(0rem);
    }
  }

  .options-row {
    width: 100%;
    height: 8rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;

    .play-button {
      width: 20rem;
      height: 2.5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.2rem;
      border: none;
      outline: none;
      border-radius: 0.2rem;
      transition: 0.3s;

      @media (max-width: 400px) {
        width: 90%;
      }

      &:hover {
        background-color: rgb(223, 223, 223);
        cursor: pointer;
      }

      span {
        margin-left: 1rem;
      }
    }

    .again-button {
      width: 20rem;
      height: 2.5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.2rem;
      border: none;
      outline: none;
      border-radius: 0.2rem;
      transition: 0.3s;

      @media (max-width: 400px) {
        width: 90%;
      }

      &:hover {
        background-color: rgb(223, 223, 223);
        cursor: pointer;
      }

      span {
        margin-left: 1rem;
      }
    }
  }

  .send-row {
    width: 100%;
    height: 7rem;
    display: flex;
    flex-direction: column;

    .label-box {
      width: 100%;
      height: 2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1rem;
      font-weight: bold;
      color: #24792b;
      border-bottom: 2px solid #2e9b37;
    }

    .send-box {
      width: 100%;
      height: 5rem;
      display: flex;
      align-items: center;
      justify-content: center;

      input {
        width: 13rem;
        height: 2.5rem;
        border: none;
        outline: none;
        border-radius: 0.2rem;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        font-size: 1rem;

        @media (max-width: 400px) {
          width: calc(60% - 0.5rem);
        }
      }

      button {
        margin-left: 1rem;
        width: 6rem;
        height: 2.5rem;
        background-color: #2c9134;
        color: white;
        font-size: 1.1rem;
        border: none;
        outline: none;
        border-radius: 0.2rem;
        transition: 0.3s;

        @media (max-width: 400px) {
          width: calc(30% - 0.5rem);
        }

        &:hover {
          cursor: pointer;
          background-color: #247e2c;
        }

        span {
          margin-left: 0.5rem;
        }
      }
      
      .sended-box {
        width: auto;
        height: 2.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.2rem;
        font-weight: bold;
        color: #24792b;

        .label-long {
          color: white;
          margin-right: 1rem;
          @media (max-width: 400px) {
            display: none;
          }
        }

        .label-mid {
          display: none;
          color: white;
          margin-right: 1rem;
          @media (max-width: 400px) {
            display: flex;
          }
          @media (max-width: 300px) {
            display: none;
          }
        }

        .label-short {
          display: none;
          color: white;
          margin-right: 1rem;
          @media (max-width: 300px) {
            display: flex;
          }
          @media (max-width: 250px) {
            display: none;
          }
        }

        .link-button {
          width: 2rem;
          height: 2rem;
          background-color: #2c9134;
          color: white;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 0.3rem;
          font-size: 1.1rem;
          margin-left: 0.5rem;
          user-select: none;
          &:hover {
            cursor: pointer;
          }
          &:active {
            transform: scale(0.9);
          }
        }

        .facebook-button {
          width: 2rem;
          height: 2rem;
          background-color: #3B5998;
          color: white;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 0.3rem;
          font-size: 1.2rem;
          margin-left: 0.5rem;
          user-select: none;
          &:hover {
            cursor: pointer;
          }
          &:active {
            transform: scale(0.9);
          }
        }

        .twitter-button {
          width: 2rem;
          height: 2rem;
          background-color: #0091ca;
          color: white;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 0.3rem;
          font-size: 1.2rem;
          margin-left: 0.5rem;
          user-select: none;
          &:hover {
            cursor: pointer;
          }
          &:active {
            transform: scale(0.9);
          }
        }
      }
    }
  }
}

.continue-button {
  width: 70%;
  height: 3rem;
  background-color: #43b64d;
  color: white;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 0.2rem;
  transition: 0.2s;
  animation: continueAppear 0.8s forwards;
  position: absolute;
  bottom: 3rem;

  @media (max-width: 600px) {
    width: 85%;
  }

  @keyframes continueAppear {
    0% {
      opacity: 0;
      transform: translateY(2rem);
    }
    100% {
      opacity: 1;
      transform: translateY(0rem);
    }
  }

  span {
    font-size: 1.2rem;
    margin-left: 1.5rem;
  }
  .icon {
    font-size: 1.3rem;
    margin-left: 0.8rem;
    margin-top: 0.1rem;
  }

  &:hover {
    background-color: #3faa48;
    cursor: pointer;
  }
}

.hide-continue {
  animation: hideContinue 1s forwards;
  @keyframes hideContinue {
    0% {
      opacity: 1;
      transform: translateY(0rem);
    }
    100% {
      opacity: 0;
      transform: translateY(2rem);
    }
  }
}

.menu-button {
  width: 3rem;
  height: 3rem;
  position: fixed;
  color: white;
  font-size: 2rem;
  z-index: 11;
  background-color: rgb(62, 64, 70);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.2rem;
  cursor: pointer;
  user-select: none;

  @media (min-width: 1000px) {
    left: 1rem;
    top: 1rem;
  }
  @media (min-width: 750px) {
    left: 1rem;
    top: 1rem;
  }
  @media (max-width: 750px) {
    right: 1rem;
    top: 1rem;
  }
}

.menu {
  width: 25rem;
  height: 100vh;
  background-color: rgb(62, 64, 70);
  position: fixed;
  z-index: 10;
  left: -25rem;
  display: flex;
  flex-direction: column;
  transition: 0.5s;
  border-right: 2px solid rgb(133, 131, 131);
  @media (max-width: 750px) {
    width: 100vw;
    left: -100vw;
  }

  .menu-title {
    width: 100%;
    min-height: 5rem;
    top: 0rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 1.8rem;
    font-weight: bold;
    color: rgb(216, 216, 216);
    padding-right: 2rem;
    border-bottom: 2px dashed rgb(133, 131, 131);
    @media (max-width: 750px) {
      justify-content: flex-start;
      padding-right: 0rem;
      padding-left: 2rem;
    }
  }

  .scroll-box {
    width: 100%;
    flex: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 0.5rem;
    padding-bottom: 2rem;
    overflow-y: auto;
  }

  .exercise-box {
    width: 85%;
    min-height: 6rem;
    margin-top: 1.5rem;
    display: flex;
    flex-direction: column;
    background-color: rgb(54, 55, 61);
    border-radius: 0.3rem;
    @media (max-width: 750px) {
      width: 90%;
    }

    .label {
      width: 100%;
      height: 2.5rem;
      display: flex;
      align-items: center;
      padding-left: 1rem;
      color: rgb(182, 180, 180);
      font-size: 1rem;
      font-weight: 800;
    }

    .title {
      width: 100%;
      height: 3.5rem;
      display: flex;
      align-items: center;
      padding-left: 1rem;
      padding-right: 1rem;
      font-size: 1.3rem;
      font-weight: 600;
      color: white;
    }
  }

  .mode-box {
    width: 85%;
    min-height: 6rem;
    margin-top: 1.5rem;
    display: flex;
    flex-direction: column;
    background-color: rgb(54, 55, 61);
    border-radius: 0.3rem;
    @media (max-width: 750px) {
      width: 90%;
    }

    .label {
      width: 100%;
      height: 2.5rem;
      display: flex;
      align-items: center;
      padding-left: 1rem;
      color: rgb(182, 180, 180);
      font-size: 1rem;
      font-weight: 800;
    }

    .title {
      width: 100%;
      height: 3.5rem;
      display: flex;
      align-items: center;
      padding-left: 1rem;
      padding-right: 1rem;
      font-size: 1.3rem;
      font-weight: 600;
      color: white;
    }
  }

  .options {
    width: 100%;
    min-height: 6rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    border-radius: 0.3rem;
    border-top: 2px dashed rgb(133, 131, 131);

    .restart {
      width: 8rem;
      height: 3rem;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      font-size: 1.3rem;
      color: white;
      cursor: pointer;
      transition: 0.2s;
      border-radius: 0.3rem;
      background-color: #e0c31f;
      font-weight: 600;

      &:hover {
        background-color: #d3b81e;
      }

      &:active {
        transform: scale(0.95);
      }
    }

    .exit {
      width: 8rem;
      height: 3rem;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      font-size: 1.3rem;
      color: white;
      cursor: pointer;
      transition: 0.2s;
      border-radius: 0.3rem;
      background-color: #ee6f69;
      font-weight: 600;

      &:hover {
        background-color: #e06761;
      }

      &:active {
        transform: scale(0.95);
      }
    }
  }
}

.visible {
  left: 0rem;
}

.loading {
  width: 100%;
  height: 100%;
  display: flex;
}
</style>